require([
    'services',
    'jquery',
    'semantic',
    'ch_utils',
    'ch_header',
    'ch_scrollto',
    'ch_welcome_overlay',
    'ch_semantic_responsive',
    'google_captcha',
], function () {
    function initializeContactPage() {
        /**
         * togglePhoneCall
         * show/hide the phone call input along with the "or" dongle
         *
         * @param boolean   enable
         */
        function togglePhoneCall(enable) {
            if (enable) {
                $phoneCallType.fadeIn();
                $emailType.removeClass('fluid');
                $orDongle.show();
            } else {
                $phoneCallType.fadeOut();
                $emailType.addClass('fluid');
                $orDongle.hide();
            }
        }

        /**
         * updateSubtopic
         *
         * Update "What is your problem" sub-topics based on the topic
         *
         * @param Element   el
         */
        function updateSubtopic(el) {
            var topic = $(el).val();

            $subtopicSelect.empty().hide();
            $subtopicContainer.hide();
            $helpfulAnswers.hide();
            $manageClassesButton.hide();
            $contactFormBody.show();
            $subtopicEmergencyContainer.hide();
            $subtopicVirtualLinkContainer.hide();
            togglePhoneCall(false);

            // remove old error messages
            $subtopicContainer.find('.prompt.label').remove();


            if (
                topic === 'emergency' ||
                topic === 'virtual_link' ||
                topic === 'press'
            ) {
                $subtopicSelect.append(selectStore);

                switch (topic) {
                    case 'emergency':
                        $subtopicEmergencyContainer.fadeIn();
                        togglePhoneCall(true);
                        $subtopicSelect.val('Emergency');
                        break;
                    case 'virtual_link':
                        $subtopicVirtualLinkContainer.fadeIn();
                        $subtopicSelect.val('Virtual Link');
                        $contactFormBody.hide();
                        break;
                    case 'press':
                        $subtopicSelect.val('Press or Media Inquiry');
                        break;
                }
            } else if (topic) {
                $subtopicContainer.fadeIn();
                $subtopicSelect.fadeIn();
                $subtopicSelect.append(selectStore);
            }

            // our "virtual_link" topic shares a sub-topic with "student" topic, so don't auto-hide it
            // when we are viewing the topic (the whole sub-topic field is already hidden)
            if (topic !== 'virtual_link') {
                // filter out all sub-topics not part of this "topic"
                $subtopicSelect
                    .find(':not(:first,[data-js=subtopic-' + topic + '])')
                    .remove();
            }

        }

        /**
         * updateAnswers
         *
         * update possible answers based on topic/sub-topic selection
         *
         * @param Element   el
         */
        function updateAnswers(el) {
            var problem = $(el).val();

            $helpfulAnswers.hide();
            $contactFormBody.show();
            $manageClassesButton.hide();
            $subtopicVirtualLinkContainer.hide();

            // remove old error messages
            $subtopicContainer.find('.prompt.label').remove();

            if (problem) {
                if (problem == 'Trouble Purchasing') {
                    togglePhoneCall(true);
                } else {
                    togglePhoneCall(false);
                }

                $answers.hide();

                if (problem == 'Canceling or Rescheduling') {
                    $contactFormBody.hide();
                    $manageClassesButton.fadeIn();
                } else if (problem == 'Virtual Link') {
                    $subtopicVirtualLinkContainer.fadeIn();
                    $contactFormBody.hide();
                } else {
                    $helpfulAnswers.fadeIn();
                    $('[data-js="answers-' + problem + '"]').fadeIn();
                }
            }
        }

        // grab a bunch of stuff!
        var $topicSelect = $('#topic');
        var $subtopicSelect = $('.js-subtopic');
        var selectStore = $subtopicSelect.html();
        var $phoneCallType = $('.phone-call-type');
        var $emailType = $('.email-type');
        var $orDongle = $('.or', '.contact-buttons');
        var $contactForm = $('#form_Contact');
        var $subtopicContainer = $('.subtopic-container');
        var $helpfulAnswers = $('.helpful-answers');
        var $subtopicEmergencyContainer = $('.subtopic-emergency-container');
        var $subtopicVirtualLinkContainer = $('.subtopic-virtual-link-container');
        var $answers = $('.answers');
        var $contactFormBody = $('#contact-form-body');
        var $manageClassesButton = $('#manage-my-classes');

        $('#user_agent').val(navigator.userAgent);

        // initialize phone call
        togglePhoneCall(false);

        // set up validation
        CH.validate('form_Contact', {
            rules: {
                phone: {
                    required: false,
                    phoneFormat: true,
                },
                name: {
                    required: false,
                },
            },
        });

        // when a user pics a new topic, update the subtopic selector
        $topicSelect.on('change', function (e) {
            updateSubtopic(this);
        });

        // when a user selects a sub topic, display related answers
        $subtopicSelect.on('change', function (e) {
            updateAnswers(this);
        });

        // initialize by triggering the topic, sub-topic and answer displays
        updateSubtopic($topicSelect);
        updateAnswers($subtopicSelect);

        $phoneCallType.on('click', function (e) {
            e.preventDefault();

            $('#contact_type').val('Phone');
            $('#phone').rules('add', 'required');

            if ($contactForm.valid()) {
                $contactForm.submit();
            }
        });

        $emailType.on('click', function (e) {
            e.preventDefault();

            $('#contact_type').val('Email');
            $('#phone').rules('remove', 'required');

            if ($contactForm.valid()) {
                $contactForm.submit();
            }
        });

        $('.emergency-toggle').on('click', function (e) {
            e.preventDefault();

            $topicSelect
                .val('emergency')
                .trigger('change');

            $('html, body').animate({
                scrollTop: $contactForm.offset().top,
            }, 500);
        });

        // initialize semantic checkboxes
        $('.ui.checkbox', '.contact-page').checkbox();

        // Show the CommunityQA Prompt based on which topic(s) the user is asking about
        var $communityMessagePrompt = $('.js-add-as-community-message-field');
        $topicSelect.on('change', function () {
            // reset the checkbox that depends on subtopic
            $communityMessagePrompt
                .hide()
                .find('input[type=checkbox]')
                .disable();
        });
        $subtopicSelect
            .on('change', function () {
                if ([
                    'Help Finding a Class',
                    'Information About a Class',
                    'Question About My Class',
                ].indexOf($(this).val()) >= 0
                ) {
                    $communityMessagePrompt
                        .show()
                        .find('input[type=checkbox]')
                        .enable();
                } else {
                    $communityMessagePrompt
                        .hide()
                        .find('input[type=checkbox]')
                        .disable();
                }
            })
            .trigger('change');

        $('.ui.accordion').accordion();
    }

    $(function () {
        initializeContactPage();
    });
});
